import { Button } from '@mgh-app/component-library';
import { useAuth } from 'auth/useAuth';
import { MainLayoutContext } from 'layouts/MainLayout';
import { useAppNavigation } from 'navigation/useAppNavigation';
import { showCreateTicketActions } from 'pages/SupportTicket';
import { useContext, useEffect } from 'react';
import { useGetSupportListQuery } from 'services/AccountService';
import { appVersion, getBaseUrl } from 'services/apiConfig';
import { useGetUserDetailsQuery } from 'services/UsersService';
import { display, flexDirection, fontSize, gap, margin, padding, textAlign, twCls } from 'style';

export const Account = (): JSX.Element => {
  const { setTitle, showNavigationButtons, showUserProfile, navigateBackAction } =
    useContext(MainLayoutContext);
  const { signOut } = useAuth();
  const {
    navigateHome,
    navigateBack,
    navigateLogin,
    navigateAbout,
    navigateEula,
    navigateCreateTicket,
    navigateEmailChange,
    navigateDataConsent,
  } = useAppNavigation();

  const { data: supportItems } = useGetSupportListQuery();
  const { data: userDetails } = useGetUserDetailsQuery();

  useEffect(() => {
    setTitle('Account');
    showNavigationButtons(true);
    showUserProfile(true);
    navigateBackAction(() => navigateHome);
    return () => navigateBackAction(() => navigateBack);
  }, [
    navigateBack,
    navigateBackAction,
    navigateHome,
    setTitle,
    showNavigationButtons,
    showUserProfile,
  ]);

  const logout = () => {
    signOut();
    navigateLogin();
  };

  const messageMyGlobalHome = () => {
    const onSelect = (index: number) => {
      const item = supportItems && supportItems[index];

      if (item) {
        navigateCreateTicket(item.id);
      }
    };

    showCreateTicketActions(supportItems || [], onSelect);
  };

  return (
    <div
      className={twCls(
        padding('pt-16'),
        display('flex'),
        gap('gap-y-3'),
        flexDirection('flex-col'),
      )}
    >
      <Button onClick={messageMyGlobalHome}>Message MyGlobalHome</Button>
      <Button onClick={navigateAbout}>About MyGlobalHome</Button>
      <Button onClick={navigateEula}>End User License Agreement</Button>
      <Button onClick={navigateDataConsent}>Data Collection</Button>
      <Button onClick={navigateEmailChange}>Change Email Address</Button>
      <Button onClick={logout}>Logout</Button>
      <ul className={twCls(margin('mt-auto'), fontSize('text-sm'), textAlign('text-center'))}>
        <li>API: {getBaseUrl()}</li>
        <li>Unit ID: {userDetails?.unitId}</li>
        <li>Version: {appVersion || 'Local Dev Build'}</li>
      </ul>
    </div>
  );
};
